import {
  ModelConceptAttribute,
  ModelConceptAttributeData,
} from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { createModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/createModelConceptAttribute';
import { updateRuleAttributeRange } from 'src/containers/ProjectDiagram/utils/rules/updateRuleAttributeRange';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setRangesForAttributeModelData =
  (value: string, rangeIris: string[]) => (model: Model) => {
    const existingAttribute =
      model.modelData.attributesByIri[value] ||
      createModelConceptAttribute({ value });

    const ranges = Object.fromEntries(
      rangeIris.map((rangeIri) => {
        const range: ModelConceptAttributeData = {
          value: rangeIri,
        };

        return [rangeIri, range];
      })
    );

    const updatedAttribute: ModelConceptAttribute = {
      ...existingAttribute,
      ranges,
    };
    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: updatedAttribute,
    });

    updateRuleAttributeRange(updatedAttribute)(model);
  };
